<template>
  <v-card color="grey lighten-4" min-width="350px" flat>
    <v-toolbar :color="eventData.color" dark>
      <v-btn icon>
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-toolbar-title v-html="eventData.name"></v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col class="d-flex" cols="12" sm="12" v-if="clientEvent">
            <v-autocomplete
              v-model="newEvent"
              :items="clientEvents"
              item-text="Name"
              item-value="_id"
              label="Event"
              @change="visit()"
            ></v-autocomplete>
          </v-col>

          <template v-if="newEvent === 'Dr. Visit'">
            <v-col cols="12" sm="12" md="6">
              <v-select
                v-model="newReviewingProvider"
                label="Providers"
                :items="providers"
                item-text="Provider.Name"
                item-value="Provider._id"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select
                v-model="newVisitType"
                label="Visit Type"
                :items="visitTypes"
                item-value="Name"
                item-text="Name"
              ></v-select>
            </v-col>
          </template>

          <v-col class="d-flex" cols="12" sm="12" v-if="staffEvent">
            <v-autocomplete
              v-model="newEvent"
              :items="staffEvents"
              item-text="Name"
              item-value="_id"
              label="Event"
            ></v-autocomplete>
          </v-col>

          <v-col class="d-flex" cols="12" sm="12" v-if="clientEvent || staffEvent">
            <v-select
              v-model="newClient"
              :items="clients"
              item-text="Name"
              item-value="_id"
              label="Client"
              @change="setProgram"
            ></v-select>
          </v-col>

          <v-col class="d-flex" cols="12" sm="12">
            <v-select
              v-model="newStaff"
              :items="users"
              item-text="Name"
              item-value="_id"
              label="Staff"
            ></v-select>
          </v-col>

          <v-col cols="6" sm="12" md="6">
            <v-datetime-picker
              v-model="newStartDate"
              label="Start Date"
              time-format="hh:mm a"
              date-format="MM/dd/yyyy"
            ></v-datetime-picker>
          </v-col>

          <v-col cols="6" sm="12" md="6">
            <v-datetime-picker
              v-model="newEndDate"
              label="End Date"
              time-format="hh:mm a"
              date-format="MM/dd/yyyy"
            ></v-datetime-picker>
          </v-col>

          <v-col cols="12" md="6">
            <v-textarea
              v-model="newNotes"
              outlined
              label="Notes of activity"
            ></v-textarea>
          </v-col>

          <v-container fluid>
            <p>Recurring Events?</p>
            <v-radio-group v-model="isRecurringEvent" mandatory>
              <v-radio label="Yes" value="Yes"></v-radio>
              <v-radio label="No" value="No"></v-radio>
            </v-radio-group>
          </v-container>

          <v-col cols="12" sm="12" md="6" v-if="isRecurringEvent === 'Yes'">
            <v-select
              :items="optionsForRecurring"
              label="More"
              v-model="selectedOption"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" sm="12">
            <v-text-field
              readonly
              v-model="DateCreated"
              label="Date Created"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12">
            <v-text-field
              readonly
              v-model="CreatedBy"
              label="Created By"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-btn class="red darken-2 white--text" text @click="showCancelModal(eventData)">Cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn class="blue darken-2 white--text" text @click="updateScheduleShift()">Update</v-btn>
      <v-btn text color="blue darken-1" @click="updateClose">Close</v-btn>
    </v-card-actions>

    <!-- Vuetify Modal Instead of Plain HTML -->
    <v-dialog v-model="showModal" persistent max-width="500px">
      <v-card>
        <v-card-title>Cancel Event</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="cancellationNote"
            placeholder="Enter cancellation reason (min 10 characters)"
            rows="4"
            cols="50"
          />
          <p v-if="cancellationNote && cancellationNote.length < 10">
            Note must be at least 10 characters (currently: {{ cancellationNote.length }})
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="cancellationNote.length < 10" @click="eventCancel">
            Confirm
          </v-btn>
          <v-btn @click="closeModal">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import {mapActions} from "vuex";
import toastr from "toastr";

const url = require("../../client_config/config").url;

export default {
  props: {
    getEvents: Function,
    updateClose: Function,
    titleForm: String,
    eventData: Object,
    clients: Array,
    clientEvents: Array,
    staffEvents: Array,
    visitTypes: Array,
    programs: Array,
    users: Array,
  },
  data: () => ({
    msg: "",
    text: "",
    clientEvent: false,
    staffEvent: false,
    clientID: localStorage.getItem("clientId"),
    drsVisit: false,
    color: "success",
    newEvent: "",
    newEventFor: "",
    newClient: "",
    newStaff: "",
    newProgram: "",
    newStartDate: "",
    newDate: "",
    newEndDate: "",
    newNotes: "",
    newTransportation: "",
    newFrom: "",
    newTo: "",
    newVisitType: "",
    newReviewingProvider: "",
    CreatedBy: "",
    DateCreated: "",
    newSignature: "",
    visitID: "",
    signature: "",
    Signed: false,
    signaturepop: false,
    startDatetime: new Date(),
    endDatetime: new Date(
      new Date().setTime(new Date().getTime() + 1 * 60 * 60 * 1000)
    ),
    textFieldProps: {
      appendIcon: "event"
    },
    startDateProps: {
      min: moment(new Date()).format("YYYY-MM-DD")
    },
    startTimeProps: {
      ampmInTitle: true
    },
    endDateProps: {
      min: moment(new Date()).format("YYYY-MM-DD")
    },
    endTimeProps: {
      ampmInTitle: true
    },
    selectedClientPrograms: [],
    providers: [],
    medicalVisit: null,
    isRecurringEvent: "No",
    optionsForRecurring: ['Daily', 'Weekly', 'Monthly', 'Annually'],
    selectedOption: "",
    recurringEventId: "",
    showModal: false,
    cancellationNote: '',
    selectedItem: null,
  }),

  async created() {
    const {
      client,
      client: {Program: clientPrograms = []},
      staff,
      program: {Name: programName = ''} = {}
    } = this.eventData;
    this.selectedClientPrograms = clientPrograms;

    await this.getProviders(client._id);

    if (client) {
      this.newClient = client;
    }

    if (staff) {
      this.newStaff = staff;
    }

    if (programName) {
      this.newProgram = programName;
    }

    this.newEvent = this.eventData.event;
    this.newEventFor = this.eventData.eventFor;
    this.newStartDate = new Date(this.eventData.startDate);
    this.newEndDate = new Date(this.eventData.endDate);
    this.newNotes = this.eventData.note;
    this.newTransportation = this.eventData.transportation;
    this.newFrom = this.eventData.Tfrom;
    this.newTo = this.eventData.Tto;
    this.CreatedBy = this.eventData.createdBy;
    this.DateCreated = this.eventData.createdDate;
    this.newSignature = this.eventData.signature;
    this.Signed = (!(this.eventData.signature === "" || this.eventData.signature === undefined));
    this.visitID = this.eventData.visitID;
    this.medicalVisit = this.eventData.medicalVisit;
    this.selectedOption = this.eventData.selectedOption ?? '';
    this.isRecurringEvent = this.eventData.isRecurringEvent ?? 'No';
    this.recurringEventId = this.eventData.recurringEventId ?? ''

    // Only execute the if-block if medicalVisit is not null and not an empty object
    if (this.medicalVisit && Object.keys(this.medicalVisit).length > 0) {
      this.medicalVisit = this.eventData.medicalVisit
      this.newReviewingProvider = this.eventData.medicalVisit.ReviewingProvider._id || '';
      this.newVisitType = this.eventData.medicalVisit.VisitType;
    }

    let checkEvent = "";
    if (this.newEventFor === "Client") {
      this.clientEvent = true;
      this.staffEvent = false;
      checkEvent = this.clientEvents.find(element => element === this.eventData.event);
      if (checkEvent === undefined) {
        this.clientEvents.push(this.eventData.event);
      }
    } else {
      this.staffEvent = true;
      this.clientEvent = false;
      checkEvent = this.staffEvents.find(element => element === this.eventData.event);
      if (checkEvent === undefined) {
        this.staffEvents.push(this.eventData.event);
      }
    }


  },
  watch: {
    'eventData': async function (nval) {
      const {client, client: {Program: clientPrograms = []}, staff, program: {Name: programName = ''} = {}} = nval;
      await this.getProviders(client._id);

      if (client) {
        this.newClient = client;
      }

      if (staff) {
        this.newStaff = staff;
      }

      if (programName) {
        this.selectedClientPrograms = clientPrograms;
        this.newProgram = programName;
      }

      this.newEvent = nval.event;
      this.newEventFor = nval.eventFor;
      this.newStartDate = new Date(nval.startDate);
      this.newEndDate = new Date(nval.endDate);
      this.newNotes = nval.note;
      this.newTransportation = nval.transportation;
      this.newFrom = nval.Tfrom;
      this.newTo = nval.Tto;
      this.CreatedBy = nval.createdBy;
      //this.getUsers(nval.createdBy);
      this.DateCreated = nval.createdDate;
      this.newSignature = nval.signature;
      this.Signed = (!(this.eventData.signature === "" || this.eventData.signature === undefined));
      this.visitID = nval.visitID;
      this.newReviewingProvider = nval.reviewingProvider;
      this.newVisitType = nval.visitType;
      this.medicalVisit = nval.medicalVisit;
      this.selectedOption = nval.selectedOption ?? '';
      this.isRecurringEvent = nval.isRecurringEvent ?? 'No';
      this.recurringEventId = this.eventData.recurringEventId ?? ''

      // Only execute the if-block if medicalVisit is not null and not an empty object
      if (this.medicalVisit && Object.keys(this.medicalVisit).length > 0) {
        this.medicalVisit = nval.medicalVisit
        this.newReviewingProvider = nval.medicalVisit.ReviewingProvider._id || '';
        this.newVisitType = nval.medicalVisit.VisitType;
      }

      let checkEvent = "";
      if (this.newEventFor === "Client") {
        this.clientEvent = true;
        this.staffEvent = false;
        checkEvent = this.clientEvents.find(element => element === this.eventData.event);
        if (checkEvent === undefined) {
          this.clientEvents.push(this.eventData.event);
        }
      } else {
        this.staffEvent = true;
        this.clientEvent = false;
        checkEvent = this.staffEvents.find(element => element === this.eventData.event);
        if (checkEvent === undefined) {
          this.staffEvents.push(this.eventData.event);
        }
      }
    },


  },
  /*
  computed: {
    newProgram: function() {
        return this.newClient.Program
      }
  },
  */
  methods: {

    ...mapActions({
      getClientProviders: "clientProviders/getItem",
    }),

    async getProviders(clientId) {
      const response = await this.getClientProviders(clientId);
      this.providers = response.data;
      this.setProgram(clientId);
    },

    updateScheduleShift() {
      let eventId = this.eventData.isRecurringEvent === 'Yes' ? this.eventData.recurringEventId : this.eventData.id

      let req_body = {
        Event: this.newEvent,
        Client: this.newClient,
        Staff: this.newStaff,
        Program: this.newProgram,
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        Notes: this.newNotes,
        Transportation: this.newTransportation,
        From: this.newFrom,
        To: this.newTo,
        CreatedBy: this.newCreatedBy,
        Signature: this.newSignature,
        ReviewingProvider: this.newReviewingProvider,
        VisitType: this.newVisitType,
        UrlNotification: this.$router.history.current.path,
        isRecurringEvent: this.isRecurringEvent,
        typeOfRecurringEvent: this.selectedOption,
      };

      if (this.newEvent === 'Dr. Visit') {
        req_body.MedicalVisit = this.medicalVisit;
      }

      axios.put(`${url}/calendar/${eventId}`, req_body)
        .then((res) => {
          if (res) {
            this.msg = true;
            this.text = "Schedule updated successfully.";
            this.color = "success";
            let emitValue = {msg: this.msg, text: this.text, color: this.color, selectedOpen: false}
            this.$emit('updateCalendarEvent', emitValue);
          }
        })
        .catch(async err => {
          if (err.response) {
            this.text = await err.response.data.msg;
            this.msg = true;
            this.color = "error";
            let emitValue = {msg: this.msg, text: this.text, color: this.color, selectedOpen: true}
            this.$emit('updateCalendarEvent', emitValue);
          }
        });
    },

    showCancelModal(item) {
      this.selectedItem = item;
      this.cancellationNote = '';
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.selectedItem = null;
      this.cancellationNote = '';
    },

    async eventCancel() {
      try {
        if (!this.cancellationNote || this.cancellationNote.length < 10) {
          toastr.error('Cancellation note must be at least 10 characters long');
          return;
        }

        const updatedItem = {
          ...this.selectedItem,
          note: this.cancellationNote
        };

        const response = await axios.put(`${url}/calendar/cancel`, updatedItem);

        if (response.status === 200 && response.data && response.data.msg) {
          this.msg = true;
          this.text = "Schedule cancelled successfully.";
          this.color = "success";
          let emitValue = {msg: this.msg, text: this.text, color: this.color, selectedOpen: true}
          this.$emit('updateCalendarEvent', emitValue);
          this.closeModal();
        } else {
          throw new Error('Unexpected response from server');
        }
      } catch (error) {
        this.text = await error.response?.data?.msg || error.message || 'Something went wrong.';
        this.msg = true;
        this.color = "error";
        let emitValue = {msg: this.msg, text: this.text, color: this.color, selectedOpen: true}
        this.$emit('updateCalendarEvent', emitValue);
      }
    },

    getSignature: function () {
      if (this.Signed === false) {
        this.Signed = false;
      }

      if (this.Signed === true) {
        this.Signed = true;
        this.newSignature = this.CreatedBy + " - " + new Date()
      }

    },

    visit() {
      if (this.newEvent === "Dr. Visit") {
        this.drsVisit = true;
      } else {
        this.drsVisit = false;
      }
    },

    setProgram(clientId) {
      const client = this.clients.find(client => client._id === clientId);

      if (client && client.Program && client.Program.length) {
        this.selectedClientPrograms = client.Program;
        this.newProgram = client.Program[0];
      }
    },

  }
}
</script>
<style scoped>
.v-application {
  justify-content: center;
}
</style>
